import { HttpContext } from "@angular/common/http";
import { SKIP_ERROR_ALERT } from "../interceptors/skip-error-alert.context";

/** HTTP context that suppresses global error toasts for optional / probe requests. */
export const SILENT_HTTP_CONTEXT = new HttpContext().set(SKIP_ERROR_ALERT, true);
